import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'src/constants/routes';
import { useLocationSearch } from 'src/helpers/hooks/useLocationSearch';
import RentersInsuranceLayout from 'src/layouts/RentersInsuranceLayout';
import { usePaymentLayoutContext } from 'src/pages/payment-msi/PaymentMsiV2/providers';

interface PaymentV2LayoutProps {
  children: ReactNode;
}

export function PaymentV2Layout({ children }: PaymentV2LayoutProps) {
  const { mobileBodyPart, isMobile, updateMobileBodyPart } =
    usePaymentLayoutContext();
  const navigate = useNavigate();
  const getUrlWithParams = useLocationSearch();
  const coveragesDetailsPageUrl = getUrlWithParams(
    ROUTES.COVERAGES_DETAIL_PATH,
  );

  const goToCoveragesDetails = () => {
    navigate(coveragesDetailsPageUrl);
  };

  function onBack() {
    if (!isMobile) {
      goToCoveragesDetails();
      return;
    }

    if (mobileBodyPart === 'checkout') {
      updateMobileBodyPart('add-parties');
      return;
    }

    goToCoveragesDetails();
  }

  return (
    <RentersInsuranceLayout
      headerProps={{
        backButtonAction: onBack,
        isStickToTop: true,
        v2: true,
      }}
      footerProps={{ withMarginTop: false }}
    >
      {children}
    </RentersInsuranceLayout>
  );
}
